import React from 'react'
import AppPieChart from './AppPieChart';
import { useAppData } from '../../../../context/AppDataContext';

function StaffPieChart({report}) {

    const {userDD,getDDDataById} = useAppData();
    const dataLabels = [];
    const chartData = [];

    report.assignedTo.forEach(assignee=>{
        if(!isNaN(assignee.assignedTo)){
            dataLabels.push(getDDDataById(userDD, assignee.assignedTo).label+" ("+assignee.count+")");
            chartData.push(assignee.count);
        }
    })
    
    return (
      <AppPieChart dataLabels={dataLabels} chartData={chartData} />
    )
}

export default StaffPieChart
